export default __webpack_public_path__ + "static/media/logo-icon.4396526e.png";